import React from 'react'

export const AppSubheading = ({ children }) => {
  return (
    <h3 className="text-tertiary-default text-lg lg:text-xl">{children}</h3>
  )
}
